// Keeps the in-cart letter badges on product cards
// (snippets/koi-card-cart-badges.liquid) and the per-koi cards' "In cart"
// tags (snippets/card-product.liquid) in sync with the cart.
//
// Initial state is server-rendered from cart.items. It re-syncs when the
// cart changes without a grid re-render (quick-add, cart drawer edits,
// bfcache restores after a koi was added or removed on a PDP) and after
// every facet/filter re-render: Dawn's facets.js caches each filter
// combination's HTML and re-inserts it on a revisit or Back, so a grid can
// come back rendered before the cart changed.
(() => {
  let syncTimer = null;

  function letterOf(variantTitle) {
    return String(variantTitle || '').split(':')[0].trim().toUpperCase();
  }

  async function syncAll() {
    const wrappers = document.querySelectorAll('[data-koi-card-cart-badges]');
    // Per-koi cards' "In cart" tags (card-product.liquid), one koi each.
    const tags = document.querySelectorAll('[data-koi-in-cart]');
    if (!wrappers.length && !tags.length) return;

    let cart;
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      cart = await res.json();
    } catch {
      return; // Non-critical — leave server-rendered state in place
    }

    // product id -> Set of in-cart letters
    const inCart = {};
    for (const item of cart.items || []) {
      (inCart[item.product_id] ||= new Set()).add(letterOf(item.variant_title));
    }

    wrappers.forEach((wrap) => {
      const letters = inCart[wrap.dataset.productId];
      wrap.querySelectorAll('.koi-card-cart-badges__badge').forEach((badge) => {
        badge.classList.toggle('is-in-cart', !!(letters && letters.has(badge.dataset.letter)));
      });
    });

    const variants = new Set((cart.items || []).map((item) => String(item.variant_id)));
    tags.forEach((tag) => {
      tag.classList.toggle('is-in-cart', variants.has(tag.dataset.variantId));
    });
  }

  function debouncedSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncAll, 150);
  }

  function init() {
    document.addEventListener('cart:refresh', debouncedSync);

    // Pub/sub cart updates (quick-add, cart drawer). Bare identifiers —
    // pubsub.js top-level consts don't attach to window.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, debouncedSync);
    }

    // bfcache restore: the server-rendered badge state is stale if the
    // cart changed on the page the visitor navigated to and back from.
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) debouncedSync();
    });

    const grid = document.getElementById('ProductGridContainer');
    if (grid) new MutationObserver(debouncedSync).observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
